import {
    GET_SAM_CATALOG_VERSIONS,
    GET_SAM_CATALOG_VERSIONS_SUCCESS,
    GET_SAM_CATALOG_VERSIONS_ERROR,
  } from '../../../constants/catalog';
  
  export const getSamKeyVersions = (state: any, actions: any) => {
    switch (actions.type) {
      case GET_SAM_CATALOG_VERSIONS:
        return {
          ...state,
          loading: true,
        };
      case GET_SAM_CATALOG_VERSIONS_ERROR:
        return {
          data: null,
          loading: false,
          error: null,
        };
      case GET_SAM_CATALOG_VERSIONS_SUCCESS:
        return {
          ...state,
          loading: false,
          error: null,
          data: actions.payload,
        };
      default:
        return state;
    }
  };
  